<template>
  <div class="wrapper">
    <el-header>
      <h3 class="title">
        <div class="block">
          <span>Web接入</span>
        </div>
      </h3>
    </el-header>
    <el-scrollbar class="scrollbar-wrap">
      <div class="web-accesscode-box">
        <div class="bigfont">网站客服接入步骤（两步）</div>
        <div class="smallfont">1.创建一个&ensp;id="aicc_entrance"&ensp;的dom元素作为入口容器</div>
        <div class="flowerbox">
          <div class="flower-linktxt">
            <code class="code-color1">&lt;div</code>
            <code class="code-color2">&ensp;id="</code>
            <code class="code-color4">aicc_entrance</code>
            <code class="code-color2">"</code>
            <code class="code-color1">&gt;&lt;/div&gt;</code>
            <el-button type="primary" @click="copy('entranceDom')" size="mini" style="margin-left:10px;">一键复制</el-button>
          </div>
        </div>
        <div class="smallfont">2.将下面一段代码复制并黏贴到你网站的标签之前，保存并发布网站，即可完成在线客服功能的植入，注意接入的网站域名需与配置页面一致。</div>
        <div class="flowerbox">
          <div class="flower-linktxt">
            <code class="code-color1">&lt;script</code>
            <code class="code-color2">&ensp;src=</code>
            <code class="code-color4">"{{scriptSrc}}"</code>
            <code class="code-color1">&gt;&lt;/script&gt;</code>
            <el-button type="primary" @click="copy('accessCode')" size="mini" style="margin-left:10px;">一键复制</el-button>
          </div>
        </div>
        <div class="bigfont">自定义“在线咨询”按钮</div>
        <div class="smallfont">如果您想自定义客服按钮，在完成上述的步骤之后，可以将下面的代码作为客服按钮的点击事件。</div>
        <div class="flowerbox">
          <div class="flower-linktxt">
            <div>
              <code class="code-color4">AICCFunc.showChatDialog({showOrHide:'show'})</code>
              <el-button type="primary" @click="copy('showCode')" size="mini" style="margin-left:10px;">一键复制</el-button>
            </div>
          </div>
        </div>
        <el-row type="flex" justify="center">
          <el-button size="medium" @click="goBack">返回</el-button>
        </el-row>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: 'AccessCode',
  data() {
    return {

    }
  },
  mounted() {
  },
  computed: {
    scriptSrc: function () {
      return this.$parent.accessScriptSrc
    }
  },
  methods: {
    // 返回
    goBack() {
      this.$parent.changeView('webList')
    },
    copy(type) {
      const oInput = document.createElement('input')
      if (type === 'accessCode') {
        oInput.value = '<script src="' + this.$parent.accessScriptSrc + '"><' + '/script>'
      } else if (type === 'showCode') {
        oInput.value = 'AICCFunc.showChatDialog({showOrHide:\'show\'})'
      } else if (type === 'entranceDom') {
        oInput.value = '<div id="aicc_entrance"></div>'
      }
      document.body.appendChild(oInput)
      oInput.select()
      document.execCommand('Copy')
      oInput.remove()
      this.$message.success('复制成功!')
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  height: 100%;
}
.scrollbar-wrap {
  height: calc(100% - 60px - 10px);
}
.el-header {
  /*height: auto !important;*/
  margin-bottom: 0;
  padding: 0;
  .title {
    /*margin-bottom: 20px;*/
  }
}

.web-accesscode-box {
  .bigfont {
    font-size: 18px;
    color: #333;
    margin-top: 10px;
    margin-bottom: 15px;
  }

  .smallfont {
    font-size: 12px;
    color: #666;
    line-height: 22px;
    margin-bottom: 10px;
  }

  .flowerbox {
    margin-bottom: 15px;
    .flower-linktxt {
      background-color: #f5f5f5;
      box-sizing: border-box;
      padding: 10px 15px;
      word-break: break-all;
      word-wrap: break-word;
      code {
        margin: 0;
        width: auto;
        text-align: left;
        font-size: 15px;
        font-family: "Microsoft YaHei";
      }

      .code-color1 {
        color: #09b8d8;
      }

      .code-color2 {
        color: #666;
      }

      .code-color3 {
        color: #18ba1f;
      }

      .code-color4 {
        color: #e96900;
      }

      div {
        line-height: 22px;
      }
    }
  }

  .web-accesscodeinput {
    margin-top: 15px;
    ::v-deep .el-form-item {
      .el-form-item__label {
        font-size: 12px;
        color: #666;
      }
      .el-input {
        width: 260px;
        margin-right: 10px;
      }
    }
  }
}
</style>
